<script setup lang="ts">
import Dialog from '@/components/dialogs/Dialog.vue';
import { FileType } from '@/enums/files';
import type { File } from '@/types/files';
import { downloadFileFromFilePreview } from '@/utils/file';
import { computed } from 'vue';

const props = defineProps<{
    file?: File;
}>();

const visible = defineModel<boolean>();

const dialogTitle = computed(() => props.file?.name || '');
</script>

<template>
    <Dialog v-if="file" v-model="visible" :title="dialogTitle">
        <template #appendTitle>
            <v-tooltip location="bottom" text="Bestand downloaden" v-slot:activator="{ props }">
                <v-icon color="primary" icon="download" @click="downloadFileFromFilePreview(file)" class="hover-main rounded-xl" v-bind="props" />
            </v-tooltip>
        </template>
        <div v-if="file.type === FileType.Pdf">
            <iframe :src="`${file.data}#toolbar=0&view=fit`" style="height: 80vh; width: 80vw" class="border-0 rounded-lg"></iframe>
        </div>
        <v-img v-else-if="file.type === FileType.Image" :src="file.data" max-width="900" max-height="75vh" width="auto" height="auto" />
        <div v-else class="card-container-small">
            <p>Er is geen voorbeeld beschikbaar voor dit bestand. Bestandsextensie (.{{ file.name.split('.')[1] }}) wordt nog niet ondersteund.</p>
            <v-btn color="primary" @click="downloadFileFromFilePreview(file)" class="mt-5"> Download </v-btn>
        </div>
    </Dialog>
</template>

<style scoped>
.card-container-small {
    max-width: 300px;
    margin: 0 auto;
}
</style>
